import CSRF from 'csrf'
import { toast } from 'vanillaToast'

document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('#modal-before_practice')
  if (!modal) {
    return null
  }

  const buttonStart = document.querySelector('.is-start')
  if (!buttonStart) {
    return null
  }

  buttonStart.addEventListener('click', () => {
    const datasetNode = document.querySelector('#modal-before_practice-data')
    const params = new FormData()
    params.append('status', 'started')

    const practiceId = datasetNode.dataset.practiceId
    fetch(`/api/practices/${practiceId}/learning.json`, {
      method: 'PATCH',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': CSRF.getToken()
      },
      credentials: 'same-origin',
      redirect: 'manual',
      body: params
    })
    .then((response) => {
      if(response.ok) {
        window.location.reload();
      }
      else if (response.status === 500) {
        toast('サーバーエラーが発生しました。しばらくしてから再試行してください。')
      }
      else{
        response.json().then((data) => {
          alert(data.error)
        })
      }
    })
    .catch((error) => {
      console.warn(error)
    })
  })
})
